import { SVGProps } from "react";
import styles from "../variants/01/sw-categories-variant-01.module.scss";

export const CategoryHybridEletricSVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 901.6 281"
    style={{
      // @ts-ignore
      enableBackground: "new 0 0 901.6 281",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path
      className={styles.st0}
      d="M207.3 178.3c23.1 0 41.9 18.8 41.9 41.9S230.4 262 207.3 262s-41.9-18.8-41.9-41.9 18.8-41.8 41.9-41.8m0-19c-33.6 0-60.9 27.3-60.9 60.9s27.3 60.9 60.9 60.9 60.9-27.3 60.9-60.9-27.3-60.9-60.9-60.9zM767.2 178.3c23.1 0 41.9 18.8 41.9 41.9S790.3 262 767.2 262s-41.9-18.8-41.9-41.9 18.8-41.8 41.9-41.8m0-19c-33.6 0-60.9 27.3-60.9 60.9s27.3 60.9 60.9 60.9 60.9-27.3 60.9-60.9-27.3-60.9-60.9-60.9z"
    />
    <path
      className={styles.st0}
      d="m901.6 167.9-.3-.8c-7.5-19.7-25.3-36.2-53.2-49.1-22-10.2-50.2-18.1-84-23.7-52.9-8.7-103.1-8.6-111-8.5-4.2-4-25-23.4-58.9-42.5C559.3 23.5 502.9 0 432.6 0c-142.5 0-279 51.5-294.1 57.3-27.8 10.8-70 12-86.9 12-23.6 0-26.7 33-28 47.1-.2 1.8-.3 3.4-.5 4.4-1.2 8.2-3.3 10.6-8.6 13.3-6.4 3.2-11.7 33.1-11.9 34.3-1.7 9.7-5 33.4.4 44.8 1.4 3 5.7 12 64.9 21.1 28.7 4.4 56.8 6.7 57.1 6.7h5.3c-.5-1.7-.8-3.3-1.2-5-1-5.1-1.6-10.4-1.6-15.8 0-44 35.8-79.9 79.9-79.9 44 0 79.9 35.8 79.9 79.9 0 5.4-.5 10.7-1.6 15.8-.3 1.7-.7 3.3-1.2 5h405.7c-.5-1.7-.9-3.3-1.2-5-1-5.1-1.6-10.4-1.6-15.8 0-44 35.8-79.9 79.9-79.9 44 0 79.9 35.8 79.9 79.9 0 5.4-.5 10.7-1.6 15.8-.3 1.7-.7 3.3-1.2 5h.4c.3 0 2 0 4.7.1 5.6.1 15.3.3 24.1.3 6.7 0 12.8-.1 16.1-.4 2-.2 4.8-1.1 7.1-4.7 5-7.9 4.6-24.3 1.1-34.1-4-11.2 3.4-33.2 3.5-33.4l.2-.9zm-8.5 35.9c3 8.5 3.4 23.4-.6 29.8-1 1.5-2 2.3-3.3 2.4-7 .6-28.3.3-38.6.1 1-5.2 1.5-10.5 1.5-16 0-46.8-38.1-84.9-84.9-84.9-46.8 0-84.9 38.1-84.9 84.9 0 5.4.5 10.7 1.5 15.8H290.7c1-5.1 1.5-10.4 1.5-15.8 0-46.8-38.1-84.9-84.9-84.9-46.8 0-84.9 38.1-84.9 84.9 0 5.4.5 10.6 1.5 15.7-42.7-3.6-111-13.3-116.5-24.9-8-16.8 5-69.3 9.3-72.5 7.2-3.6 10-7.8 11.3-17 .2-1.2.3-2.7.5-4.6 1.2-12.7 4-42.6 23-42.6 21.3 0 61.2-1.6 88.7-12.3 15-5.8 150.7-57 292.3-57 69.2 0 124.7 23.1 159 42.5 37.3 21 58.5 42.3 58.7 42.5l.8.8h1.1c.5 0 54.3-.9 111.2 8.5 51.7 8.5 116.5 27.3 133 68.8-1.5 4.4-7.3 24.3-3.2 35.8z"
    />
    <path
      className={styles.st0}
      d="M395.8 112.4h-25.6c-2.7 0-5-2.2-5-5 0-2.7 2.2-5 5-5h25.6c2.7 0 5 2.2 5 5s-2.2 5-5 5zM616 88.2c1.6 0 2.2-2 .9-2.9-19-13-105.8-68.5-201.4-68.5-97.4 0-197.3 28.8-216.5 34.6-1.4.4-1.8 2.3-.6 3.2 7.1 5.9 27.6 21.7 43.7 21.7 18.7 0 331.2 12.3 373.9 11.9z"
    />
  </svg>
);
